import React, { useEffect, useState } from 'react';
import { Select, MenuItem, FormControl, InputLabel, Box, SelectChangeEvent, Checkbox, ListItemText } from '@mui/material';

type SelectsDatesProps = {
    onChangeDates: (value: string) => void;
};

export const SelectsDates = ({onChangeDates}: SelectsDatesProps) => {
  const [selectedMonths, setSelectedMonths] = useState<string[]>([]);
  const [selectedDays, setSelectedDays] = useState<string[]>([]);
  const [combinedString, setCombinedString] = useState<string>('');

  const months = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ];

  const days = Array.from({ length: 31 }, (_, index) => (index + 1).toString());
  const handleMonthChange = (event: SelectChangeEvent<string[]>) => {
    setSelectedMonths(event.target.value as string[]);
  };

  const handleDayChange = (event: SelectChangeEvent<string[]>) => {
    setSelectedDays(event.target.value as string[]);
  };

  useEffect(() => {
    const combined = JSON.stringify({
      days: selectedDays,
      months: selectedMonths
    });
    setCombinedString(combined);
  }, [selectedDays, selectedMonths]);

  useEffect(() => {
    onChangeDates(combinedString);
  }, [combinedString]);

  return (
    <Box display="flex" gap={2}>
      <FormControl fullWidth>
        <InputLabel id="select-month-label">Mês</InputLabel>
        <Select
          labelId="select-month-label"
          multiple
          value={selectedMonths}
          onChange={handleMonthChange}
          renderValue={(selected) => selected.join(', ')}
        >
          {months.map((month) => (
            <MenuItem key={month} value={month}>
              <Checkbox checked={selectedMonths.indexOf(month) > -1} />
              <ListItemText primary={month} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Select para dias com múltiplos itens */}
      <FormControl fullWidth>
        <InputLabel id="select-day-label">Dia</InputLabel>
        <Select
          labelId="select-day-label"
          multiple
          value={selectedDays}
          onChange={handleDayChange}
          renderValue={(selected) => selected.join(', ')} // Exibe os itens selecionados
        >
          {days.map((day) => (
            <MenuItem key={day} value={day}>
              <Checkbox checked={selectedDays.indexOf(day) > -1} />
              <ListItemText primary={day} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};